import React from "react";
import NotFound from "../template/NotFound";

export default () => <NotFound />;
